class BahnenApp {
    constructor() {
        new BlogVideoHero();
        this.hyphenateHeadings();
    }

    hyphenateHeadings = () => {
        let hyphenSelector = Array.from(
            document.querySelectorAll(".hyphenate")
        );

        hyphenSelector.forEach((element) => {
            let str = element.innerHTML;
            element.innerHTML = str
                .replaceAll(/\|\|/gi, "<br>")
                .replaceAll(/\|/gi, "&shy;")
                .replaceAll(/_/gi, "&nbsp;");
        });
    };
}

new BahnenApp();

class LightBox {
    constructor() {
        const lightbox = GLightbox({
            draggable: "true",
        });
    }
}

const lightbox = new LightBox();

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

// jQuery script to fill a parent container with an image without whitespace.
$(window).on("load resize", function () {
    /*
  $('.card .resize-img').resizeToParent({
    parent: '.card-media-container'
  });
  * */
    var userAccept = getCookie("cookie_consent_user_accepted");
    var stickyStatus = getCookie("sticky");
    if (stickyStatus == 1 && userAccept == "true") {
        $(".sticky-element").addClass("timedout");
        setTimeout(function () {
            $(".sticky-element").css({ opacity: "1" });
        }, 500);
    } else {
        $(".sticky-element").css({ opacity: "1" });
        setTimeout(function () {
            $(".sticky-element").addClass("timedout");
            setCookie("sticky", 1, 7);
        }, 5000);
    }

    if ($(window).width() <= 991) {
        $(".sticky-element a").on("click", function (e) {
            e.preventDefault();
            if ($(this).parent().hasClass("timedout")) {
                $(this).parent().removeClass("timedout");
            } else {
                window.location.href = $(this).attr("href");
            }
        });
    }
});

$(window).on("scroll", function () {
    setTimeout(function () {
        if ($(".sticky-element").not(".timedout")) {
            $(".sticky-element").addClass("timedout");
        }
    }, 1000);
});

//anchor scrolling
$("a[href*=\\#c]:not([href=\\#])").click(function (e) {
    e.preventDefault();
    if (
        location.pathname.replace(/^\//, "") ===
            this.pathname.replace(/^\//, "") &&
        location.hostname === this.hostname
    ) {
        var target = $(this.hash);
        target = target.length
            ? target
            : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
            $("html,body").animate(
                {
                    scrollTop: target.offset().top - 110,
                },
                500
            );
            return false;
        }
    }
});

// When the user scrolls down 20px from the top of the document, show the button
let $button = $("#to-top-btn");
if ($button.length > 0) {
    $button.on("click", function () {
        $("html, body").animate(
            {
                scrollTop: 0,
            },
            600
        );
    });

    window.addEventListener("scroll", function () {
        scrollFunction();
    });

    function scrollFunction() {
        if (
            document.body.scrollTop > 20 ||
            document.documentElement.scrollTop > 20
        ) {
            document.getElementById("to-top-btn").classList.remove("hide");
        } else {
            document.getElementById("to-top-btn").classList.add("hide");
        }
    }

    // init
    scrollFunction();
}

$(document).ready(function () {
    $("#sliderModal")
        .on("show.bs.modal", function (event) {
            let button = $(event.relatedTarget),
                video = button.data("video"),
                label = button.data("label"),
                modal = $(this);
            modal.find("#sliderModalLabel").html(label);
            modal.find("#videoIf").attr("src", video);
        })
        .on("hide.bs.modal", function (event) {
            let modal = $(this);
            modal.find("#videoIf").attr("src", "");
            // console.log("hide md");
        });

    // pagination search text copy
    if ($(".s-input-value").length > 0) {
        $(".s-input-value").replaceWith($(".hero-suche-input").val());
    }

    // teaser ajax pagination
    if ($(".tx-wmd-teasers").length > 0) {
        $(".tx-wmd-teasers").teaserAjaxLoader();
    }

    $(window).on("resize load", function () {
        if ($(window).width() < 888 && $("#lokfuehrertest").length > 0) {
            $("#lokfuehrertest").hide();
            if (!$("#error").length > 0) {
                $(".container.content")
                    .first()
                    .append(
                        '<p class="pb-3" id="error">Entschuldigung - der Selbsttest kann auf Ihrem Gerät leider nicht dargestellt werden.</p>'
                    );
            }
        } else {
            $("#lokfuehrertest").show();
            if ($("#error").length > 0 && $("#lokfuehrertest").length > 0) {
                $("#error").remove();
            }
        }
    });
});

$.fn.cookie = function () {
    return this.each(function () {
        const $t = $(this);

        if (getCookie("dataprivacy_wmd") === "1") {
            addGascript();
        } else {
            $t.fadeIn();
        }

        $t.on("click", ".btn-success", function (e) {
            e.preventDefault();

            setCookie("dataprivacy_wmd", "1");
            addGascript();
            $t.fadeOut(500);
        });

        function setCookie(key, value) {
            var expires = new Date();
            expires.setTime(expires.getTime() + 15768000000); //half year
            document.cookie =
                key + "=" + value + ";expires=" + expires.toUTCString;
        }

        function getCookie(key) {
            var keyValue = document.cookie.match(
                "(^|;) ?" + key + "=([^;]*)(;|$)"
            );
            return keyValue ? keyValue[2] : null;
        }

        function addGascript() {
            window.dataLayer = window.dataLayer || [];

            function gtag() {
                dataLayer.push(arguments);
            }

            gtag("js", new Date());
            gtag("config", "UA-107522281-1", { anonymize_ip: true });
        }
    });
};

$.fn.teaserAjaxLoader = function () {
    return this.each(function () {
        var elem = $(this);
        var recordUid = $(this).data("recordUid");
        var nextUrl = elem.find(".f3-widget-paginator .next a").prop("href");

        elem.on("click", ".load-more", function (e) {
            e.preventDefault();

            $.ajax({
                url: nextUrl,
            })
                .done(function (data) {
                    let currData = $(data).find(
                        '.tx-wmd-teasers[data-record-uid="' + recordUid + '"]'
                    );
                    let children = $(currData)
                        .find(".teasers-container")
                        .clone()
                        .children()
                        .css("opacity", 0);

                    elem.find(".f3-widget-paginator").remove();
                    elem.find(".teasers-container").append(children);
                    children.animate({ opacity: 1 }, 1000);

                    if (
                        currData.find(".f3-widget-paginator .next a").length > 0
                    ) {
                        nextUrl = currData
                            .find(".f3-widget-paginator .next a")
                            .prop("href");
                    } else {
                        elem.find(".load-more").hide();
                    }

                    $(".card .resize-img").resizeToParent({
                        parent: ".card-media-container",
                    });
                })
                .fail(function (error) {
                    elem.find(".load-more").hide();
                });
        });
    });
};
// Open video Lightbox on click
$("a.trailer, a.making-of-play").on("click", function (e) {
    e.preventDefault();
    let videoRef = $(this).attr("data-video-reference");
    let $videoRef = $("#" + videoRef);
    $videoRef.toggleClass("disabled");
});

$(".video-lightbox .close").on("click", function (e) {
    e.preventDefault();

    var video = $(this).parents(".video-lightbox").find(".video-frame");
    var clone = video.clone();
    clone.insertAfter($(this));
    video.remove();

    $(this).parents(".video-lightbox").toggleClass("disabled");
});

let swiper = new Swiper(".swiper-container", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

function g_recaptcha_callback() {
    $("#g-recaptcha-error").hide();
}

if (document.cookie.indexOf("hide-stick-element") > -1) {
    $(".sticky-element .btn-close").parent().addClass("hide");
} else {
    $(".btn-close").on("click", function (e) {
        $(".sticky-element .btn-close").parent().addClass("hide");
        document.cookie = "hide-stick-element=true; max-age=; path=/";
    });
}

var teaserSlider = new Swiper(".teaser-slider", {
    slidesPerView: "auto",
    spaceBetween: 26,
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

if (document.querySelector(".hero-image-slider")) {
    let heroSwiper = new Swiper(".hero-swiper", {
        slidesPerView: "auto",
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: true,
        },
        spaceBetween: 30,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
}

// Counter Element
const counterElements = Array.from(document.querySelectorAll(".value"));

const observer = new IntersectionObserver((entries) => {
    entries.map((entry) => {
        if (entry.isIntersecting) {
            let count = +entry.target.getAttribute("data-counter-start");
            let speed = +entry.target.getAttribute("data-counter-speed") || 50;
            const end = +entry.target.getAttribute("data-counter-end");
            const stepsByDivisor = 10;

            const interval = setInterval(() => {
                entry.target.textContent = count;

                if (count >= end) {
                    clearInterval(interval);
                } else {
                    count += Math.ceil((end - count) / stepsByDivisor);
                    count = Math.min(count, end);
                }
            }, speed);
        }
    });
});

counterElements.map((element) => observer.observe(element));

const videoSliders = Array.from(
    document.querySelectorAll(".video-text-container")
);

videoSliders.map((slider) => {
    const container = slider.querySelector(".video-content");
    const nextVideoButton = slider.querySelector(
        '[data-video-controller="next"]'
    );

    if (nextVideoButton) {
        nextVideoButton?.addEventListener("click", () => {
            let firstVideoElement = container?.firstElementChild;
            let video = firstVideoElement?.cloneNode(true);

            nextVideoButton.setAttribute("disabled", true);
            video.classList.add("not-available");

            firstVideoElement.classList.add("transition");

            firstVideoElement.addEventListener("transitionend", () => {
                firstVideoElement?.remove();
                container.append(video);

                setTimeout(() => {
                    nextVideoButton.removeAttribute("disabled");
                    container.lastElementChild.classList.remove(
                        "not-available"
                    );
                }, 300);
            });
        });
    }
});
